import {RecoveryPayment} from "@secca/shared/models/recoveryPayment";
import {DropdownDictionary} from "@secca/shared/models/dropdownDictionary";

export class CaseEconomyRecoveryPaymentDialogData {
  caseNumber: string;
  payment: RecoveryPayment;
  serviceItemOptions: DropdownDictionary[];
  recoveryOptions: DropdownDictionary[];
  paymentUpdated?: any
}
